import { createAsyncThunk } from '@reduxjs/toolkit';

import { setDailyReminderTime as setDailyReminderTimeService } from './services';

const SET_DAILY_REMINDER_TIME = 'SET_DAILY_REMINDER_TIME';
export const setDailyReminderTime = createAsyncThunk(
  SET_DAILY_REMINDER_TIME,
  setDailyReminderTimeService,
);
